"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockCopyPasteDirective = void 0;
/**
   * Block Copy and Paste Directive
   *
   */
class BlockCopyPasteDirective {
    constructor() {
    }
    blockPaste(event) {
        event.preventDefault();
    }
    blockCopy(event) {
        event.preventDefault();
    }
    blockCut(event) {
        event.preventDefault();
    }
}
exports.BlockCopyPasteDirective = BlockCopyPasteDirective;
//# sourceMappingURL=blockcopypaste.directive.js.map